import { render, staticRenderFns } from "./CreateNotesDialog.vue?vue&type=template&id=2c99176f"
import script from "./CreateNotesDialog.vue?vue&type=script&lang=js"
export * from "./CreateNotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports